export const authUtils = {
  // Store tokens with expiration
  storeTokens: (accessToken, refreshToken) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    // Set expiration time for tokens
    const tokenExpiry = new Date().getTime() + 15 * 60 * 1000; // 15 minutes
    localStorage.setItem("tokenExpiry", tokenExpiry.toString());
  },

  // Clear all stored tokens and user data
  clearStoredTokens: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("tokenExpiry");
    // Clear any other stored user data if needed
    localStorage.removeItem("userProfile");
    localStorage.removeItem("selectedAddress");
  },

  // Get access token
  getAccessToken: () => {
    return localStorage.getItem("accessToken");
  },

  // Get refresh token
  getRefreshToken: () => {
    return localStorage.getItem("refreshToken");
  },

  // Get both tokens
  getTokens: () => ({
    accessToken: localStorage.getItem("accessToken"),
    refreshToken: localStorage.getItem("refreshToken")
  }),

  // Check if user is authenticated (token exists and not expired)
  isAuthenticated: () => {
    const token = localStorage.getItem("accessToken");
    const expiry = localStorage.getItem("tokenExpiry");
    if (!token || !expiry) return false;
    return new Date().getTime() < parseInt(expiry);
  },

  // Get user profile
  getUserProfile: () => {
    const profile = localStorage.getItem("userProfile");
    return profile ? JSON.parse(profile) : null;
  },

  // Store user profile
  storeUserProfile: (profile) => {
    localStorage.setItem("userProfile", JSON.stringify(profile));
  },

  // Update tokens after refresh
  updateTokens: (accessToken, refreshToken) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);

    // Update expiration time
    const tokenExpiry = new Date().getTime() + 15 * 60 * 1000; // 15 minutes
    localStorage.setItem("tokenExpiry", tokenExpiry.toString());
  },

  // Check if token is about to expire (within 2 minutes)
  isTokenExpiringSoon: () => {
    const expiry = localStorage.getItem("tokenExpiry");
    if (!expiry) return true;

    const expiryTime = parseInt(expiry);
    const currentTime = new Date().getTime();
    const twoMinutes = 2 * 60 * 1000;
    return expiryTime - currentTime <= twoMinutes;
  }
};
